/* unplugin-vue-components disabled */import script from "./MenuFold.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuFold.vue?vue&type=script&setup=true&lang=ts"

import "./MenuFold.vue?vue&type=style&index=0&id=15ad4f4b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15ad4f4b"]])

export default __exports__